import { APP_VERSION } from 'app-constants'
import platform from 'components/Trackers/platform'
import { getFunnelName, getFlow } from 'utils/FlowProvider/utils'
import { isDynamicFunnelEnabled, retrieveMetadata } from 'utils/FunnelContext/utils'
import { getTierPrice } from 'utils/TieredRegistration/utils'

/**
 * Modifies event payload to match standard for web events.
 * @param event Event payload.
 * @param getSourceAttributes Function to retrieve the source attributes (signup page enhance).
 * @return Standardized event.
 */
export const translateEventProps = (
  event: Record<string, any>,
  getSourceAttributes?: () => Record<any, any>,
): Record<string, unknown> => {
  const funnel = isDynamicFunnelEnabled() ? retrieveMetadata().name : getFunnelName(getFlow())

  // DA team has requested we only set source attributes on specific events
  // Since they only care for top-of-funnel and this reduces cost
  const sourceAttributes = getSourceAttributes?.()
  const parsedSourceAttributes = sourceAttributes ? JSON.parse(sourceAttributes.attributes) : null

  // Native clients use `platforms` while web currently uses `platform`
  // Analytics team has asked us to keep `platform` since all the reporting utilizes this property
  delete event.platforms

  const tierPrice = event.tier_price ?? getTierPrice()

  // Native clients use `tier_price` in the eventing specification
  delete event.tier_price

  return {
    ...event,
    ...(parsedSourceAttributes && {
      sourceAttributes: {
        attributes: parsedSourceAttributes,
        sourceId: sourceAttributes.id,
      },
    }),
    platform,
    funnel,
    tier: `$${tierPrice}_tier`,
    tierPrice,
    app_version: APP_VERSION,
  }
}
